import BenchlingConfig from 'BenchlingConfig';
import {getPartyDisplayString} from 'parties/GetPartyDisplayString';
import {getLegacyRequestObjectName, Request} from 'requests/RequestConstants';
import {readableTime} from 'util/DateUtil';
import * as ExportUtil from 'util/ExportUtil';

interface RequestCSVColumn {
  header: string;
  getter: (request: Request) => string;
}

export function getBaseColumns(): Array<RequestCSVColumn> {
  return [
    {header: `${getLegacyRequestObjectName()} ID`, getter: (request) => request.name},
    {header: 'API Identifier', getter: (request) => request.id},
    {header: 'Status', getter: (request) => request.requestStatus},
    BenchlingConfig.REQUESTS_ENABLE_REQUESTOR
      ? {header: 'Requestor', getter: (request) => getPartyDisplayString(request.requestor)!}
      : {header: 'Creator', getter: (request) => getPartyDisplayString(request.creator)!},
    {header: 'Created', getter: (request) => readableTime(request.createdAt, {showTime: false})},
    {
      header: 'Assigned To',
      getter: (request) =>
        request.assignees.map((assignee) => getPartyDisplayString(assignee.user || assignee.team)).join(','),
    },
    {header: 'Scheduled On', getter: (request) => readableTime(request.scheduledOn, {showTime: false})},
  ];
}

function selectedTagNames(selectedRequests: Array<Request>): Array<string> {
  const tagNames: Array<string> = [];
  for (const request of selectedRequests) {
    for (const tag of request.tags) {
      if (!tagNames.includes(tag.name)) {
        tagNames.push(tag.name);
      }
    }
  }
  return tagNames;
}

function makeCSVHeader(tagNames: Array<string>): Array<string> {
  return [...getBaseColumns().map((column) => column.header), ...tagNames];
}

function makeCSVRow(request: Request, tagNames: Array<string>): Array<string> {
  return [
    ...getBaseColumns().map((column) => column.getter(request)),
    ...tagNames.map((tagName) => {
      const tag = request.tags.find((requestTag) => requestTag.name === tagName);
      return tag == null ? '' : tag.value || '';
    }),
  ];
}

export function requestsToCSV(selectedRequests: Array<Request>): string {
  const tagNames = selectedTagNames(selectedRequests);
  const header = makeCSVHeader(tagNames);
  const rows = selectedRequests.map((request) => makeCSVRow(request, tagNames));
  return ExportUtil.formatRows([header, ...rows], ',');
}
